import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants'

export const federalReviewActions = {
    load: () => dispatch => {
        dispatch(federalReviewActions.loadRequest());
        messageCenterService.loadFederalReviews()
            .then(
                messages => {
                    dispatch(federalReviewActions.loadSuccess(messages));
                },
                error => {
                    dispatch(federalReviewActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.FED_REV_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.FED_REV_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.FED_REV_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.FED_REV_LOAD_FAILURE),

    setSelectedMessage: createAction(ActionNames.FED_REV_SET_SELECTED_MESSAGE),

    changeSelection: (nono) => (dispatch, getState) => {
        dispatch(federalReviewActions.setSelectedMessage({ nono }));


        if (!getState().entities.federalReviewMsgs[nono].isRead) {
            dispatch(federalReviewActions.markReadRequest({ nono }));

            messageCenterService.markReadNotification(nono)
                .then(
                    () => { dispatch(federalReviewActions.markReadSuccess(nono)) }
                    ,
                    error => {
                        dispatch(federalReviewActions.markReadFailure({ nono, error }));
                        dispatch(alertActions.error(Errors.FED_REV_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.FED_REV_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.FED_REV_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.FED_REV_MARK_READ_FAILURE),

    reply: (mxno, reply, toUrno) => dispatch => {
        dispatch(federalReviewActions.replyRequest({ mxno }));

        messageCenterService.prwsReply(undefined, mxno, undefined, reply, toUrno)
            .then(
                () => { dispatch(federalReviewActions.replySuccess(mxno)) }
                ,
                error => {
                    dispatch(federalReviewActions.replyFailure({ mxno, error }));
                    dispatch(alertActions.error(Errors.FED_REV_REPLY_FAILURE));
                }
            );
    },
    replyRequest: createAction(ActionNames.FED_REV_REPLY_REQUEST),
    replySuccess: createAction(ActionNames.FED_REV_REPLY_SUCCESS),
    replyFailure: createAction(ActionNames.FED_REV_REPLY_FAILURE),

    toggleReply: createAction(ActionNames.FED_REV_TOGGLE_REPLY),

    closeNotification: (nono) => (dispatch, getState) => {
        dispatch(federalReviewActions.closeNotificationRequest({ nono }));
        let mxno = getState().entities.federalReviewMsgs[nono].nomxno;
        messageCenterService.closeNotification(nono)
            .then(
                () => { dispatch(federalReviewActions.closeNotificationSuccess({nono, mxno})) }
                ,
                error => {
                    dispatch(federalReviewActions.closeNotificationFailure({ nono, error }));
                    dispatch(alertActions.error(Errors.FED_REV_CLOSE_NOTIFICATION_FAILURE));
                }
            );
    },
    closeNotificationRequest: createAction(ActionNames.FED_REV_CLOSE_NOTIFICATION_REQUEST),
    closeNotificationSuccess: createAction(ActionNames.FED_REV_CLOSE_NOTIFICATION_SUCCESS),
    closeNotificationFailure: createAction(ActionNames.FED_REV_CLOSE_NOTIFICATION_FAILURE),


}
